import {Datepicker} from 'vanillajs-datepicker';
import da from 'vanillajs-datepicker/js/i18n/locales/da.js';

export const initCheckout = () => {

    const addressSwitchCheckbox = document.querySelector('#shippingbillingsame');
    const billingAddressHolder = document.querySelector('#PaymentForm_OrderForm_SilverShop-Checkout-Component-BillingAddress_Holder');
    const shippingAddressHolder = document.querySelector("#PaymentForm_OrderForm_SilverShop-Checkout-Component-ShippingAddress_Holder");

    //Disable autocomplete - by removing autocomplete you can see the calender. In chrome.
    const form = document.querySelector('#PaymentForm_OrderForm')
    const deliveryDate = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-DateCheckoutComponent_DeliveryDate')
    const returnDate = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-DateCheckoutComponent_ReturnDate')

    //Checkout and account order views
    const orderView = document.querySelector('.js-order-view')
    const paymentOptionsHolder = document.querySelector('#OrderActionsForm_ActionsForm_PaymentMethod');

    if (orderView) {
        if (paymentOptionsHolder) {
            const paymentOptions = paymentOptionsHolder.querySelectorAll('input')

            if (paymentOptions) {
                paymentOptions.forEach(paymentOption => {
                    paymentOption.setAttribute('name', 'PaymentMethod')
                });
            }
        }
    }

    if (form) {
        form.setAttribute('autocomplete', 'off');

        [deliveryDate, returnDate].forEach(input => {
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('aria-autocomplete', 'none');
            input.setAttribute('role', 'presentation');
        });
    }

    if (shippingAddressHolder && addressSwitchCheckbox) {
        let shippingFields = shippingAddressHolder.querySelectorAll('input');

        const updateBillingFields = () => {
            shippingFields.forEach(element => {
                let shippingFieldId = element.id;
                let paymentFieldId = shippingFieldId.replace("-Shipping", "-Billing");
                let updateField = document.querySelector("#" + paymentFieldId);

                if (updateField) {
                    updateField.value = element.value;
                }
            });
        };

        shippingFields.forEach(element => {
            element.addEventListener('input', () => {
                if (!addressSwitchCheckbox.checked) {
                    updateBillingFields();
                }
            });
        });

        addressSwitchCheckbox.addEventListener('change', (e) => {
            if (e.target.checked) {
                billingAddressHolder.classList.add('is-shown');

                shippingFields.forEach(element => {
                    let shippingFieldId = element.id;
                    let paymentFieldId = shippingFieldId.replace("-Shipping", "-Billing");
                    let billingField = document.querySelector("#" + paymentFieldId);

                    if (billingField) {
                        billingField.value = '';
                    }
                });
            } else {
                billingAddressHolder.classList.remove('is-shown');
                updateBillingFields();
            }
        });

        if (!addressSwitchCheckbox.checked) {
            updateBillingFields();
        }
    }


    const startDate = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-DateCheckoutComponent_DeliveryDate');
    if (startDate) {

        Object.assign(Datepicker.locales, da);

        let disabled_delivery_days = [];
        if (disable_weekend_delivery) {
            disabled_delivery_days = [0, 6]
        }

        const datepicker = new Datepicker(startDate, {
            format: 'dd/mm/yyyy',
            minDate: new Date(),
            weekStart: 1,
            daysOfWeekDisabled: disabled_delivery_days,
            language: 'da',
            autohide: true
        });

        const triggerDeliveryDateReload = () => {
            const val = startDate.value.trim();
            if (val.length === 10) {
                sendAndReload('DeliveryDate', val);
            } else if (val === '') {
                sendAndReload('DeliveryDate', '');
            }
        };

        datepicker.element.addEventListener('changeDate', triggerDeliveryDateReload);
        startDate.addEventListener('input', triggerDeliveryDateReload);

    }

    const endDate = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-DateCheckoutComponent_ReturnDate');
    if (endDate) {

        //Object.assign(Datepicker.locales, da);

        let disabled_return_days = [];
        if (disable_weekend_return) {
            disabled_return_days = [0, 6]
        }

        const datepicker = new Datepicker(endDate, {
            format: 'dd/mm/yyyy',
            minDate: new Date(),
            weekStart: 1,
            daysOfWeekDisabled: disabled_return_days,
            language: 'da',
            autohide: true
        });

        const triggerReturnDateReload = () => {
            const val = endDate.value.trim();
            if (val.length === 10) {
                sendAndReload('ReturnDate', val);
            } else if (val === '') {
                sendAndReload('ReturnDate', '');
            }
        };

        datepicker.element.addEventListener('changeDate', triggerReturnDateReload);
        endDate.addEventListener('input', triggerReturnDateReload);
    }

    // Move fields to the right place
    const target = document.getElementById('checkout-finish')
    const shippingField = document.getElementById('PaymentForm_OrderForm_Nobrainer-Shipping-Checkout-NobrainerShippingCheckoutComponent_Holder');
    if (shippingField) {
        target.appendChild(shippingField);
    }
    const buttonOne = document.getElementById('PaymentForm_OrderForm_action_checkoutSubmit');
    const buttonTwo = document.getElementById('PaymentForm_OrderForm_action_checkAgeBeforePayment');
    if (buttonOne) {
        target.appendChild(buttonOne.parentNode);
    }
    if (buttonTwo) {
        target.appendChild(buttonTwo.parentNode);
    }

    const sendAndReload = function (field, value) {
        const data = new FormData();
        data.append(field, value);
        fetch('/checkout/updatedata/', {
            method: 'POST',
            body: data
        }).then(function (response) {
            return response.text();
        }).then(function (html) {
            replaceShippingOptions(html)
        });
    }

    const initShippingFields = () => {
        // If shipping method has changed, update shipping options
        const shippingMethodFields = document.querySelectorAll('input[name="Nobrainer-Shipping-Checkout-NobrainerShippingCheckoutComponent_ShippingMethodID"]');
        if (shippingMethodFields) {
            shippingMethodFields.forEach(function (field) {
                field.addEventListener('change', function () {
                    sendAndReload('ShippingMethodID', field.value);
                });
            });
        }
    }

    initShippingFields();

    const initBaseRateShipping = () => {
        const zipField = document.querySelector('#SilverShop-Checkout-Component-ShippingAddress_PostalCode');
        const spansSelector = '.js-delivery-option-baserate';

        const refreshBaseRatePlaceholders = () => {
            const spans = document.querySelectorAll(spansSelector);
            if (!spans.length) return;

            const zip = zipField ? (zipField.value || '').trim() : '';
            const hasValidZip = zip.length === 4;

            spans.forEach(span => {
                if (!span.dataset.originalText) {
                    span.dataset.originalText = span.textContent.trim();
                }

                if (!hasValidZip) {
                    span.textContent = 'Oplys postnummer for pris';
                } else {
                    if (span.dataset.originalText) {
                        span.textContent = span.dataset.originalText;
                    }
                }
            });
        };

        refreshBaseRatePlaceholders();

        if (zipField && !zipField.dataset.baserateBound) {
            zipField.addEventListener('input', () => {
                refreshBaseRatePlaceholders();
            });
            zipField.dataset.baserateBound = '1';
        }
    };

    initBaseRateShipping();

    const replaceShippingOptions = (html) => {
        const shippingOptions = document.getElementById('PaymentForm_OrderForm_Nobrainer-Shipping-Checkout-NobrainerShippingCheckoutComponent_Holder');
        const newDom = document.createElement('div');
        newDom.innerHTML = html;
        const newOptions = newDom.querySelector('#PaymentForm_OrderForm_Nobrainer-Shipping-Checkout-NobrainerShippingCheckoutComponent_Holder');
        if (shippingOptions) {
            shippingOptions.innerHTML = newOptions.innerHTML;
        }
        initShippingFields();
        initBaseRateShipping();
    }

    const zipField = document.querySelector('#SilverShop-Checkout-Component-ShippingAddress_PostalCode');
    if (zipField) {
        zipField.addEventListener('input', (e) => {
            if (e.target.value && e.target.value.length === 4) {
                sendAndReload("ZipCode", e.target.value);
            }
        });
    }

    // Old mechanism
    // //Checkout Delivery Cost Ajax
    // const methodField = document.querySelector('#PaymentForm_OrderForm_SilverShop-Shipping-Checkout-Component-ShippingCheckoutComponent_ShippingMethodID');
    //
    //
    // const priceLabel = document.querySelector('.js-delivery-price-update td');
    // const totalLabel = document.querySelector('.js-update-total > td');
    // const taxLabel = document.querySelector('.js-delivery-tax > td');
    //
    // if (!(methodField && priceLabel && totalLabel))
    //     return;
    //
    // const action = '/checkout/updateCheckout';
    //
    //
    // const handleCheckoutChange = () => {
    //     const deliveryType = methodField.querySelector(':checked').value;
    //     const params = '?deliveryType=' + deliveryType;
    //
    //     fetch(action + params).then((response) => {
    //         if (response.ok) return response.json();
    //         else console.warn('Async error: Could not update checkout.', response);
    //     }).then((json) => {
    //         if (deliveryType) {
    //             const dkkSpan = document.createElement('span')
    //             dkkSpan.textContent = 'DKK'
    //
    //             priceLabel.textContent = json.freightLabel + ' ';
    //             priceLabel.appendChild(dkkSpan)
    //
    //             totalLabel.textContent = ' ' + json.total;
    //             totalLabel.insertBefore(dkkSpan.cloneNode(true), totalLabel.firstChild)
    //
    //             taxLabel.textContent = json.tax + ' ';
    //             taxLabel.appendChild(dkkSpan.cloneNode(true))
    //         }
    //     });
    // };
    //
    // methodField.addEventListener('change', handleCheckoutChange);
    // handleCheckoutChange();

    const isCompanyInput = document.querySelector('input.js-iamcompany');

    const updateIsCompany = function (isCompany) {
        const data = new FormData();
        data.append('isCompany', isCompany ? "1" : "0");
        fetch('/checkout/updateiscompany/', {
            method: 'POST',
            body: data
        })
            .then(response => response.text())
            .catch(error => console.error('Error updating company info:', error));
    };

    if (isCompanyInput) {
        const shippingVatHolder = document.querySelector('#SilverShop-Checkout-Component-ShippingAddress_VAT_Holder');
        const billingVatHolder = document.querySelector('#SilverShop-Checkout-Component-BillingAddress_VAT_Holder');
        const shippingCompanyHolder = document.querySelector('#PaymentForm_OrderForm_SilverShop-Checkout-Component-ShippingAddress_Company_Holder');
        const billingCompanyHolder = document.querySelector('#PaymentForm_OrderForm_SilverShop-Checkout-Component-BillingAddress_Company_Holder');
        const shippingEanHolder = document.querySelector('#PaymentForm_OrderForm_SilverShop-Checkout-Component-ShippingAddress_EAN_Holder');
        const billingEanHolder = document.querySelector('#PaymentForm_OrderForm_SilverShop-Checkout-Component-BillingAddress_EAN_Holder');

        function toggleCompanyFields(isChecked) {
            // Show & enable fields if checked
            if (isChecked) {
                if (shippingVatHolder) {
                    shippingVatHolder.classList.add('show');
                    shippingVatHolder.querySelector('input').removeAttribute('disabled');
                }
                if (billingVatHolder) {
                    billingVatHolder.classList.add('show');
                    billingVatHolder.querySelector('input').removeAttribute('disabled');
                }
                if (shippingEanHolder) {
                    shippingEanHolder.classList.add('show');
                    shippingEanHolder.querySelector('input').removeAttribute('disabled');
                }
                if (billingEanHolder) {
                    billingEanHolder.classList.add('show');
                    billingEanHolder.querySelector('input').removeAttribute('disabled');
                }
                if (shippingCompanyHolder) {
                    shippingCompanyHolder.classList.add('show');
                    shippingCompanyHolder.querySelector('input').removeAttribute('disabled');
                }
                if (billingCompanyHolder) {
                    billingCompanyHolder.classList.add('show');
                    billingCompanyHolder.querySelector('input').removeAttribute('disabled');
                }
            }
            // Hide & disable fields if unchecked
            else {
                if (shippingVatHolder) {
                    shippingVatHolder.classList.remove('show');
                    const input = shippingVatHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
                if (billingVatHolder) {
                    billingVatHolder.classList.remove('show');
                    const input = billingVatHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
                if (shippingEanHolder) {
                    shippingEanHolder.classList.remove('show');
                    const input = shippingEanHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
                if (billingEanHolder) {
                    billingEanHolder.classList.remove('show');
                    const input = billingEanHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
                if (shippingCompanyHolder) {
                    shippingCompanyHolder.classList.remove('show');
                    const input = shippingCompanyHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
                if (billingCompanyHolder) {
                    billingCompanyHolder.classList.remove('show');
                    const input = billingCompanyHolder.querySelector('input');
                    input.value = '';
                    input.setAttribute('disabled', '');
                }
            }
        }

        toggleCompanyFields(isCompanyInput.checked);
        updateIsCompany(isCompanyInput.checked);

        isCompanyInput.addEventListener('change', () => {
            toggleCompanyFields(isCompanyInput.checked);
            updateIsCompany(isCompanyInput.checked);
        });
    }


    const newUserCheckbox = document.querySelector('input.js-newusercheckbox');
    const passwordInput = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-NoFillMembership_Password_Password');
    const confirmPasswordInput = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-NoFillMembership_Password_ConfirmPassword');

    if (newUserCheckbox) {
        const membershipHolder = document.querySelector('#PaymentForm_OrderForm_Nobrainer-App-Extensions-NoFillMembership_Holder');

        function togglePasswordFields(isChecked) {
            if (membershipHolder) {
                if (isChecked) {
                    membershipHolder.classList.add('show');
                    membershipHolder.classList.remove('hide');
                } else {
                    membershipHolder.classList.remove('show');
                }
            }

            if (passwordInput) {
                passwordInput.disabled = !isChecked;
            }

            if (confirmPasswordInput) {
                confirmPasswordInput.disabled = !isChecked;
            }
        }

        togglePasswordFields(newUserCheckbox.checked);

        newUserCheckbox.addEventListener('change', () => {
            togglePasswordFields(newUserCheckbox.checked);
        });
    }

};

export default function initStickyCheckoutCart() {
    let sticky_cart = new Sticky('.js-sticky-checkout-cart', {
        stickyClass: "sticky-active",
        stickyFor: 1023,
    });

}

function debounce(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, delay);
    };
}